module.exports = __webpack_public_path__ + "static/media/IconCalendarWeek.9e7976e0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/IconCalendarWeek.svg
// module id = 937
// module chunks = 0